import { render, staticRenderFns } from "./CustomerView.vue?vue&type=template&id=edc122ac"
import script from "./CustomerView.vue?vue&type=script&lang=js"
export * from "./CustomerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edc122ac')) {
      api.createRecord('edc122ac', component.options)
    } else {
      api.reload('edc122ac', component.options)
    }
    module.hot.accept("./CustomerView.vue?vue&type=template&id=edc122ac", function () {
      api.rerender('edc122ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/CustomerView.vue"
export default component.exports